import { environment } from '../../environments/environment';

export class AppSettings {
    //public static webApiURL='http://localhost:35257';
    //public static webApiURL='http://usilence.go-net.co.il/usilenceApi';
    public static webApiURL = environment.baseUrl; 
 }


// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/shared/AppSettings.ts